import { render, staticRenderFns } from "./CrewContainer.vue?vue&type=template&id=08dbfeaf"
import script from "./CrewContainer.vue?vue&type=script&lang=js"
export * from "./CrewContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports